import { get } from 'lodash'
import { useMemo } from 'react'

import { DropdownAttribute } from '@/components/Form/AudienceTargeting/Audience/interfaces'
import { withField, withFieldProps } from '@/components/Form/FieldWrappers/withField'
import ListBox from '@/components/GenericForm/ListBox'
import cn from '@/utilities/cn'

interface AttributeDropdownProps {
  selectedAttribute?: DropdownAttribute
  attributeOptions: DropdownAttribute[]
  onAttributeChange?: (values: DropdownAttribute) => void
  readOnly?: boolean
}
const AttributeDropdown = ({
  name,
  form: { errors, touched },
  selectedAttribute,
  onAttributeChange,
  attributeOptions,
  readOnly = false
}: AttributeDropdownProps & withFieldProps) => {
  const showErrors = !!get(touched, name) && !!get(errors, name) && !selectedAttribute

  return useMemo(() => {
    return (
      <div className={cn(['form__select', 'trigger-event', { 'form__field--error': showErrors }])}>
        <ListBox
          className="min-w-[200px]"
          onChange={e => {
            const selectedIndex = Number(e.value)
            if (selectedIndex !== -1) {
              onAttributeChange && onAttributeChange(attributeOptions[selectedIndex])
            }
          }}
          error={showErrors}
          disabled={readOnly}
          name={`${name}.operator`}
          value={attributeOptions.findIndex(attr => attr.id === get(selectedAttribute, 'id'))}
          options={[{ label: 'Select an attribute', value: -1 }].concat(
            attributeOptions.map((attribute, idx) => ({
              value: idx,
              label: attribute.displayName
            }))
          )}
        />
      </div>
    )
  }, [attributeOptions, showErrors, onAttributeChange, selectedAttribute, readOnly, name])
}
export default withField(AttributeDropdown)
